var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { AmericanStyle, MultiviewStyle } from "../../SecondaryHeadingContentTypes";
import { SecondaryHeadingContent } from "../../SecondaryHeadingContent";
var RenderSubheading = /** @class */ (function (_super) {
    __extends(RenderSubheading, _super);
    function RenderSubheading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RenderSubheading.prototype.getContentType = function () {
        var HeadingContentStyles = {
            American: AmericanStyle,
            Regular: SecondaryHeadingContent,
            Multiview: MultiviewStyle
        };
        return HeadingContentStyles[this.props.cardType];
    };
    RenderSubheading.prototype.render = function () {
        var shouldExpand = this.props.renderedHeadings < this.props.cms.ExpandedGroupItems;
        var eventsCount = this.props.cms.ShowLeaguesEventsCount
            ? "(" + this.props.eventsCountLength + ")"
            : "";
        var props = __assign({}, this.props, { shouldExpand: shouldExpand, eventsCount: eventsCount });
        var ContentType = this.getContentType();
        return React.createElement(ContentType, __assign({ key: "subheading-content-" + this.props.id }, props), this.props.children);
    };
    return RenderSubheading;
}(React.PureComponent));
export { RenderSubheading };
//# sourceMappingURL=RenderSubheading.js.map